<template>
    <div
        :id="id"
        class="--row lni-u-gap2"
        :class="classString"
    >
        <div class="lni-c-box--content --card --col__1of3">
            <p class="lni-u-type--xs lni-u-line-height--tight lni-u-mb1">
                {{ `${content?.shiftStart} ${name.toLowerCase()} ${content?.discomfortLevel}` }}
            </p>
            <span class="--label --number">
                {{ shiftStartDiscomfort >= 0 ? shiftStartDiscomfort : placeholder }}
            </span>
        </div>
        <div class="lni-c-box--content --card --col__1of3">
            <p class="lni-u-type--xs lni-u-line-height--tight lni-u-mb1">
                {{ ` ${content?.shiftEnd} ${name.toLowerCase()} ${content?.discomfortLevel}` }}
            </p>
            <span class="--label --number">
                {{ shiftEndDiscomfort >= 0 ? shiftEndDiscomfort : placeholder }}
            </span>
        </div>
        <div class="lni-c-box--content --card --col__1of3">
            <p class="lni-u-type--xs lni-u-line-height--tight lni-u-mb1">
                {{ `${name} ${content?.discomfortChange}` }}
            </p>
            <span class="--label --number">
                {{ shiftStartDiscomfort >= 0 && shiftEndDiscomfort >= 0
                    ? discomfortChange(shiftStartDiscomfort, shiftEndDiscomfort)
                    : placeholder }}
            </span>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

import {
    discomfortChange,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/helpers';

export default {
    name: 'LniJanitorialDiscomfortLevel',
    props: {
        classString: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            required: true,
        },
        name: { // Capitalize
            type: String,
            required: true,
        },
        shiftEndDiscomfort: {
            type: Number,
            default: -1,
        },
        shiftStartDiscomfort: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            placeholder: '---',
        };
    },
    computed: {
        ...mapGetters({
            content: 'appState/content',
        }),
    },
    methods: {
        discomfortChange(start, end) {
            return discomfortChange(start, end);
        },
    },
};
</script>
